export default "__VITE_ASSET__BRH$XTAT__"